export const VARIANT_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const CONTROL_VARIANT_NAME = "control";
export const CENTS_PER_DOLLAR = 100;
export const CENTS_PARAMETERS = new Set(["installment_amount"]);
export const EMPTY_CONDITION_GROUP = {name: "", match_mode: "all" as const, conditions: []};
